import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const SiteMap = () => {
  return (
    <div>
      <Container fluid className="careers-banner-container p-0">
        <section className="careers-inner-banner-section"></section>
      </Container>
      <Container className="my-5">
        <section className="site-map-section mx-5 px-xl-5">
          <div className="mb-5">
            <h3>Services</h3>
            <ul className="subtopics">
              <li>
                <a href="/gen-ai-banking">AI Banking</a>
              </li>
              <li>
                <a href="/enterprise-ai">Enterprise AI</a>
              </li>
              <li>
                <a href="/data-analytics">Data & Analytics</a>
              </li>
              <li>
                <a href="/next-gen-modernization">Next-Gen Modernization</a>
              </li>
              <li>
                <a href="/cloud-innovations">Cloud Innovations</a>
              </li>
              <li>
                <a href="/managed-cybersecurity">Managed Cybersecurity</a>
              </li>
            </ul>
          </div>
          <div className="mb-5">
            <h3>Resources</h3>
            <ul className="subtopics">
              <li>
                <a href="/blog">Blogs</a>
              </li>
              <li>
                <a href="/success-stories">Partner Story</a>
              </li>
              <li>
                <a href="/case-studies">Case Studies</a>
              </li>
              <li>
                <a href="/news-and-events">News & Events</a>
              </li>
              <li>
                <a href="/videos">Videos</a>
              </li>
              <li>
                <a href="/contract-vehicles">Contract Vehicles</a>
              </li>
            </ul>
          </div>
          {/* <h3 className="mb-5">
            <a href="/careers">Careers</a>
          </h3> */}
          <h3>About Us</h3>
          <ul className="subtopics">
            <li>
              <a href="/company-overview">Company Overview</a>
            </li>
            <li>
              <a href="/our-leadership">Leadership Team</a>
            </li>
            <li>
              <a href="/careers">Careers</a>
            </li>
            <li>
              <a href="/contact-us">Contact Us</a>
            </li>
          </ul>
          {/* <h3 className="mb-5">
            <a href="/contact-us">Contact Us</a>
          </h3> */}
        </section>
      </Container>
    </div>
  );
};

export default SiteMap;
